import { render, staticRenderFns } from "./News.vue?vue&type=template&id=3a4ba55a&"
import script from "./news.js?vue&type=script&lang=js&"
export * from "./news.js?vue&type=script&lang=js&"
import style0 from "./news.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports